import BusinessIcon from '@mui/icons-material/Business';
import { withClarityTheme } from '@verifime/styles';
import { EntityTypeTile } from '../EntityTypeTile';

export type PublicCompanyTileProps = {
  /**
   * Whether this tile is currently selected
   */
  selected?: boolean;
  /**
   * Callback when the tile is clicked
   */
  onClick?: () => void;
  /**
   * Optional data-testid for testing
   */
  dataTestId?: string;
};

/**
 * PublicCompanyTile is a pre-configured EntityTypeTile for the Public Company entity type.
 *
 * @example
 * ```tsx
 * <PublicCompanyTile
 *   selected={selectedType === 'public-company'}
 *   onClick={() => setSelectedType('public-company')}
 * />
 * ```
 */
const PublicCompanyTileComponent = ({
  selected,
  onClick,
  dataTestId,
}: Readonly<PublicCompanyTileProps>) => {
  return (
    <EntityTypeTile
      icon={<BusinessIcon />}
      // The title is copied in person-api (Greengate-Fintech/person-api), the label mapping in
      // src/main/java/com/greengate/verifime/service/notification/InviteEmailEntityData.java,
      // and sent by CustomerInvitedNotificationHandler (event/vertx). Change both together.
      title="Public Company"
      description="A business with “Ltd” in its name that can sell shares to the public, often listed on a stock exchange."
      hint="Choose this if your company is publicly listed or raising funds from the public."
      selected={selected}
      onClick={onClick}
      dataTestId={dataTestId}
    />
  );
};

export const PublicCompanyTile = withClarityTheme(PublicCompanyTileComponent);
